import React from 'react';
import moment from 'moment';
import CalendarMonthNavigator from './CalendarMonthNavigator';
import CalendarWeekNavigator from './CalendarWeekNavigator';
import CalendarHeaderMonth from './CalendarHeaderMonth';
import CalendarHeaderDates from './CalendarHeaderDates';

export default class CalendarLayout extends React.Component {
  constructor(props) {
    super(props);
    this.scrollInitialized = false;
    this.handleClickDate = this.handleClickDate.bind(this);
    this.handleMouseOverDate = this.handleMouseOverDate.bind(this);
    this.handleMouseOutDate = this.handleMouseOutDate.bind(this);
    this.state = {
      scrollTop: 0,
      scrollLeft: 0,
      bottomPosition: null,
      datesRangeSelected: [],
    };
  }

  render() {
    const bottom = document.querySelector('.dates-header.bottom');
    if (bottom && bottom.offsetTop > 0 && !this.scrollInitialized) {
      this.initScroll();
    }
    const { scrollTop, scrollLeft, bottomPosition } = this.state;
    const { minYear, maxYear, year, month, day, calendarDates } = this.props;
    const styleBottom = bottomPosition ? { top: scrollTop + bottomPosition } : {};

    return (
      <div className="calendar-container">
        <div className="dates-buttons top" style={ { top: scrollTop, left: scrollLeft } }>
          <table>
            <tbody>
              <tr className="month-navigator">
                <td>
                  <CalendarMonthNavigator
                    minYear={ minYear }
                    maxYear={ maxYear }
                    year={ year }
                    month={ month }
                    day={ day }
                    onChange={ this.props.onChangeDate } />
                </td>
              </tr>
              <tr className="week-navigator">
                <td>
                  <CalendarWeekNavigator
                    minYear={ minYear }
                    maxYear={ maxYear }
                    year={ year }
                    month={ month }
                    day={ day }
                    onChange={ this.props.onChangeDate } />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="dates-header top" style={ { top: scrollTop } }>
          <table>
            <tbody>
              <CalendarHeaderMonth calendarDates={ calendarDates } />
              <CalendarHeaderDates
                calendarDates={ calendarDates }
                datesRangeSelected={ this.state.datesRangeSelected }
                onClickDate={ this.handleClickDate }
                onMouseOverDate={ this.handleMouseOverDate }
                onMouseOutDate={ this.handleMouseOutDate } />
            </tbody>
          </table>
        </div>
        {
          React.cloneElement(this.props.children, { scrollLeft, calendarDates, datesRangeSelected: this.state.datesRangeSelected })
        }
        <div className="dates-buttons bottom" style={ { ...styleBottom, left: scrollLeft } }></div>
        <div className="dates-header bottom" style={ styleBottom }>
          <table>
            <tbody>
              <CalendarHeaderDates
                calendarDates={ calendarDates }
                datesRangeSelected={ this.state.datesRangeSelected }
                onClickDate={ this.handleClickDate }
                onMouseOverDate={ this.handleMouseOverDate }
                onMouseOutDate={ this.handleMouseOutDate } />
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  initScroll() {
    const calendarContainer = document.querySelector('.calendar-container');
    const bottomPosition = document.querySelector('.dates-header.bottom').offsetTop;
    calendarContainer.style.height = `568px`;
    calendarContainer.addEventListener('scroll', () => {
      const scrollTop = calendarContainer.scrollTop;
      const scrollLeft = calendarContainer.scrollLeft;
      this.setState({ scrollTop, scrollLeft, bottomPosition });
    });
    this.scrollInitialized = true;
  }

  handleClickDate(date) {
    if (!this.props.onDatesRangeSelected) return null;
    let datesRangeSelected = this.state.datesRangeSelected.slice();
    if (datesRangeSelected.length === 2) {
      datesRangeSelected.sort((a, b) => a.localeCompare(b));
      this.props.onDatesRangeSelected(datesRangeSelected);
      datesRangeSelected = [];
    } else if (datesRangeSelected.length === 1 && datesRangeSelected[0] === date) {
      datesRangeSelected.push(date);
      this.props.onDatesRangeSelected(datesRangeSelected);
      datesRangeSelected = [];
    } else {
      datesRangeSelected.push(date);
    }
    this.setState({ datesRangeSelected });
  }
  handleMouseOverDate(date) {
    const datesRangeSelected = this.state.datesRangeSelected.slice();
    if (datesRangeSelected.length === 1 && datesRangeSelected[0] !== date) {
      datesRangeSelected.push(date);
      this.setState({ datesRangeSelected });
    }
  }
  handleMouseOutDate(date) {
    const datesRangeSelected = this.state.datesRangeSelected.slice();
    if (datesRangeSelected.length === 2) {
      datesRangeSelected.splice(1, 1);
      this.setState({ datesRangeSelected });
    }
  }
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/CalendarLayout.jsx